import React from 'react';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const scrollToPricing = () => {
    const pricingSection = document.querySelector('.pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const aboutSection = document.querySelector('.about-us');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3 className="footer-heading">Product</h3>
          <ul className="footer-links">
            <li><button onClick={scrollToPricing} className="footer-link">Pricing</button></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="footer-heading">Company</h3>
          <ul className="footer-links">
            <li><button onClick={scrollToAbout} className="footer-link">About</button></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="footer-heading">Resources</h3>
          <ul className="footer-links">
            <li><a href="/privacy-policy" className="footer-link">Privacy Policy</a></li>
            <li><a href="/terms" className="footer-link">General Terms and Conditions</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="footer-heading">Connect</h3>
          <ul className="footer-links">
            <li><a href="https://www.linkedin.com/company/gordiananalytics" target="_blank" rel="noopener noreferrer" className="footer-link">LinkedIn</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright">© 2025 Gordian Analytics. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
